import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  Nav,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import {Link} from 'react-router-dom';

// Helper
import {
  checkBackend,
  checkFrontend,
  checkDoSurveys
} from '../../components/Authorization'


class ManageDropdown extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  renderUserMenu() {
    if ( checkBackend(this.props.state) ) {
      return (
        <DropdownItem tag={Link} to="/users/list">
          Users
        </DropdownItem>
      );
    }
  }

  renderSurveysMenu() {
    if ( checkBackend(this.props.state) ) {
      return (
        <DropdownItem tag={Link} to="/surveys/list">
          Surveys
        </DropdownItem>
      );
    }
  }

  renderEmployeePositionsMenu() {
    if ( checkBackend(this.props.state) ) {
      return (
        <DropdownItem tag={Link} to="/employees/list">
          Employee Positions
        </DropdownItem>
      );
    }
  }

  render() {
    return (
      <Dropdown className="px-3" nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav caret>
          Manage
        </DropdownToggle>
        <DropdownMenu>
          {this.renderUserMenu()}
          {this.renderSurveysMenu()}
          {this.renderEmployeePositionsMenu()}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

const mapStateToProps = (state) => ({
  state: state
});

export default connect(mapStateToProps)(ManageDropdown);


// WEBPACK FOOTER //
// ./src/components/Header/ManageDropdown.js